import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { WizardTypeRefinementItem } from "./refinement-items"

export const NoticeWizardServiceTypeRefinement = ({
  wizard_ref,
  proceed,
  current_wizard_service_type_refinement,
  set_current_wizard_service_type_refinement,
}) => {
  const {
    allFile: { images },
  } = useStaticQuery(graphql`
    {
      allFile(filter: { name: { regex: "/-wizard/" } }, sort: { name: ASC }) {
        images: nodes {
          name
          childImageSharp {
            gatsbyImageData(
              width: 110
              formats: [AUTO, AVIF]
              layout: CONSTRAINED
              placeholder: BLURRED
            )
          }
        }
      }
    }
  `)

  const type_refinement_items = [
    { name: "Bauleistungen", label: "Bau&shy;leistungen" },
    { name: "Dienstleistungen", label: "Dienst&shy;leistungen" },
    { name: "Lieferleistungen", label: "Liefer&shy;leistungen" },
  ]
  return (
    <div ref={wizard_ref}>
      <p className="title is-5 has-text-mitternachtsblau has-text-centered">
        Für welche Leistungsart interessieren Sie sich?
      </p>
      <div className="columns is-mobile">
        {type_refinement_items.map(({ name, label }) => {
          return (
            <WizardTypeRefinementItem
              {...{
                set_current_wizard_service_type_refinement,
                proceed,
                isRefined: current_wizard_service_type_refinement === name,
                key: name,
                name,
                label,
                image: images?.find(
                  (img) => img.name === `${name.toLowerCase()}-wizard`
                )?.childImageSharp?.gatsbyImageData,
                image_faint: images?.find(
                  (img) => img.name === `${name.toLowerCase()}-wizard-faint`
                )?.childImageSharp?.gatsbyImageData,
              }}
            />
          )
        })}
      </div>
    </div>
  )
}
